import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Images from "../../assets/images/Images";
import { useMutation, useQuery } from "@tanstack/react-query";
import { executiveData } from "../common/globalapi/Api";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

const ViewExecutive = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const navigate = useNavigate();

    const {
        control,
        handleSubmit,
        watch,
        formState: { errors },
    } = useForm();

    const [selectedRows, setSelectedRows] = useState([]);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const selectedStatus = watch("status");

    const [popupType, setPopupType] = useState({
        type: "",
        data: "",
    });

    const handleClosePopup = () => {
        setIsPopupOpen(false);
        setPopupType({
            type: "",
            data: "",
        });
    };

    // GET API START
    const { data, isLoading, isError, refetch } = useQuery({
        queryKey: ["executive"],
        queryFn: executiveData,
        refetchOnWindowFocus: false,
    });

    let details = (data && data?.data) || [];

    // GET API END

    // Filter By search
    const filteredDetails =
        details &&
        details?.filter((item) => {
            const nameMatch = item?.executiveName
                ?.toLowerCase()
                .includes(searchTerm.toLowerCase());
            const idMatch = String(item?.employeeId).includes(searchTerm); // assuming `id` is a number or string
            const statusMatch = !selectedStatus || item?.status === selectedStatus;
            return (nameMatch || idMatch) && statusMatch;
        });

    // Dashboard Details
    let totalLength = details && details?.length;

    const activeCount =
        filteredDetails &&
        filteredDetails?.filter((item) => item?.status?.toLowerCase() === "active")
            .length;
    const inactiveCount =
        filteredDetails &&
        filteredDetails?.filter(
            (item) => item?.status?.toLowerCase() === "inactive"
        ).length;

    // DELETE API
    // Delete a user by ID (use registerId in path)
    const companyDetails = (() => {
        try {
            return JSON.parse(localStorage.getItem("companyDetails") || "{}");
        } catch (e) {
            return {};
        }
    })();

    const deleteUser = async (id) => {
        try {
            const regId = companyDetails?.id;
            const response = await axios.delete(
                `${process.env.REACT_APP_HOST}/api/executive/delete/${regId}/${id}`
            );
            return response.data;
        } catch (error) {
            console.error(`Error deleting user with ID ${id}:`, error);
            throw error;
        }
    };

    const deleteUsers = async (ids) => {
        try {
            const results = await Promise.all(
                ids?.map(async (id) => {
                    return await deleteUser(id);
                })
            );
            return results; // Return all results after deletion
        } catch (error) {
            console.error("Error deleting multiple users:", error.message);
            throw new Error("Failed to delete multiple users");
        }
    };
    // Mutation to delete users
    const { mutate, isLoading: deleteLoading } = useMutation({
        mutationFn: deleteUsers,
        onSuccess: () => {
            toast.success("Executive(s) deleted successfully");
            setSelectedRows([]);
            refetch();
        },
        onError: (error) => {
            console.error("Error deleting rows:", error);
            toast.error("Error deleting rows");
        },
    });

    // Handle checkbox change
    const handleCheckboxChange = (id) => {
        setSelectedRows((prevSelectedRows) => {
            const isSelected = prevSelectedRows?.includes(id);
            if (isSelected) {
                return prevSelectedRows?.filter((rowId) => rowId !== id);
            } else {
                return [...prevSelectedRows, id];
            }
        });
    };
    // Handle delete button click
    const handleDelete = () => {
        if (selectedRows?.length === 0) {
            alert("No rows selected");
            return;
        }
        mutate(selectedRows);
    };

    // DELETE API END

    // Download Excel
    const downloadExcel = () => {
        // Define headers
        const headers = [
            "S.NO",
            "EXECUTIVE NAME",
            "PHONE NUMBER",
            "ALTERNATE PHONE NUMBER",
            "EMAIL ID",
            "PAN NUMBER",
            "AADHAR NUMBER",
            "ADDRESS",
            "CITY",
            "PINCODE",
            "ROLE",
            "STATUS",
        ];

        // Map data to match the headers order
        const formattedData =
            filteredDetails &&
            filteredDetails?.map((item, index) => ({
                "S.NO": index + 1,
                "EXECUTIVE NAME": item?.executiveName || "",
                "PHONE NUMBER": item?.phoneNumber || "",
                "ALTERNATE PHONE NUMBER": item?.alternativePhNo || "",
                "EMAIL ID": item?.email || "",
                "PAN NUMBER": item?.panNumber || "",
                "AADHAR NUMBER": item?.aadharNo || "",
                ADDRESS: item?.address || "",
                CITY: item?.city || "",
                PINCODE: item?.pincode || "",
                ROLE: item?.role || "",
                STATUS: item?.status || "",
            }));

        // Create a new workbook and a worksheet
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(formattedData, { header: headers });

        // Append the worksheet to the workbook
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        // Generate Excel file and trigger download
        XLSX.writeFile(wb, "View Executives.xlsx");
    };

    return (
        <>
            <div className="view_form_block">
                <div className="view_form_sub_block">
                    <div className="row my-3 d-flex justify-content-center">
                        <div className="col-12 col-sm-6 col-md-4 col-lg-2 dashborad-card-block --first-block">
                            <span className="dashboard-heading" style={{ color: "#6B7280" }}>
                                Overall
                            </span>
                            <span className="dashboard-value" style={{ color: "#111827" }}>
                                {totalLength || 0}
                            </span>
                        </div>
                        <div className="col-12 col-sm-6 col-md-4 col-lg-2 dashborad-card-block">
                            <span className="dashboard-heading" style={{ color: "#059669" }}>
                                Active
                            </span>
                            <span className="dashboard-value" style={{ color: "#059669" }}>
                                {activeCount || 0}
                            </span>
                        </div>
                        <div className="col-12 col-sm-6 col-md-4 col-lg-2 dashborad-card-block --last-block">
                            <span className="dashboard-heading" style={{ color: "#DC2626" }}>
                                Inactive
                            </span>
                            <span className="dashboard-value" style={{ color: "#DC2626" }}>
                                {inactiveCount || 0}
                            </span>
                        </div>
                    </div>
                    {/* Filter Card */}
                    <div className="card border-0 shadow-sm p-3 mb-4 bg-white">
                        <div className="row g-3 align-items-center">
                            {/* Search Input */}
                            <div className="col-12 col-md-4">
                                <input
                                    type="search"
                                    className="view_table_search w-100"
                                    placeholder="Search by name, ID"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>

                            <div className="col-12 col-md-8 d-flex flex-wrap gap-3 align-items-center justify-content-center justify-content-md-end">
                                {/* Status Filter */}
                                <div className="col-auto w-100-mobile">
                                    <Controller
                                        name="status"
                                        control={control}
                                        render={({ field }) => (
                                            <select {...field} className="view-table-status">
                                                <option value="">STATUS</option>
                                                <option value="Active">Active</option>
                                                <option value="Inactive">Inactive</option>
                                            </select>
                                        )}
                                    />
                                </div>

                                <div className="col-auto w-100-mobile">
                                    <div
                                        className="download_btn_block_purchase"
                                        onClick={() => {
                                            navigate("/newExecutive");
                                        }}
                                    >
                                        <button className="download_btn">NEW EXECUTIVE</button>
                                    </div>
                                </div>

                                <div className="col-auto w-100-mobile">
                                    <div className="download_btn_block" onClick={() => { downloadExcel(); }}>
                                        <button className="download_btn">DOWNLOAD</button>
                                    </div>
                                </div>

                                {/* Delete Button */}
                                {selectedRows?.length !== 0 ? (
                                    <>
                                        <div
                                            className="download_btn_block"
                                            onClick={() => {
                                                const confirmed = window.confirm(
                                                    "Are you sure you want to delete the executive details?"
                                                );
                                                if (confirmed) {
                                                    handleDelete();
                                                }
                                            }}
                                        >
                                            <button className="download_btn">DELETE</button>
                                        </div>
                                    </>
                                ) : (
                                    <></>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="row px-3 my-3">
                        <div className="col-lg-12 view_table_section">
                            <div className="table-responsive view_table_block">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th className="view-table-heading">SELECT</th>
                                            {/* <th className="view-table-heading">EXECUTIVE ID</th> */}
                                            <th className="view-table-heading">EXECUTIVE NAME</th>
                                            <th className="view-table-heading">ROLE</th>
                                            <th className="view-table-heading">EMAIL ID</th>
                                            <th className="view-table-heading">PHONE NUMBER</th>
                                            <th className="view-table-heading">ADDRESS</th>
                                            <th className="view-table-heading">STATUS</th>
                                            {/* <th className="view-table-heading">INCENTIVE</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {isLoading ? (
                                            <>
                                                <tr>
                                                    <td colSpan={8} className="text-center">

                                                        <h5 className="my-3">L O A D I N G . . .</h5>
                                                    </td>
                                                </tr>
                                            </>
                                        ) : filteredDetails?.length > 0 ? (
                                            <>
                                                {filteredDetails?.map((data, i) => {
                                                    return (
                                                        <>
                                                            <tr
                                                                key={i}
                                                                onClick={() => {
                                                                    navigate("/newExecutive", { state: data });
                                                                }}
                                                                style={{ cursor: "pointer" }}
                                                            >
                                                                <td
                                                                    className="view-table-data"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                    }}
                                                                >
                                                                    <input
                                                                        type="checkbox"
                                                                        style={{
                                                                            accentColor: "blue",
                                                                            width: "18px",
                                                                            height: "18px",
                                                                            cursor: "pointer",
                                                                        }}
                                                                        checked={selectedRows?.includes(data?.id)}
                                                                        onChange={() =>
                                                                            handleCheckboxChange(data?.id)
                                                                        }
                                                                    />
                                                                </td>
                                                                {/* <td className="view-table-data">
                                                                    {data?.id || "-"}
                                                                </td> */}
                                                                <td className="view-table-data">
                                                                    {data?.executiveName || "-"}
                                                                </td>
                                                                <td className="view-table-data">
                                                                    {data?.role || "-"}
                                                                </td>
                                                                <td className="view-table-data">
                                                                    {data?.email || "-"}
                                                                </td>
                                                                <td className="view-table-data">
                                                                    {data?.phoneNumber || "-"}
                                                                </td>
                                                                <td className="view-table-data">
                                                                    {data?.address || "-"}
                                                                </td>
                                                                <td className="view-table-data">
                                                                    {data?.status || "-"}
                                                                </td>
                                                                {/* <td className="view-table-data"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        navigate("/incentiveView")
                                                                    }}
                                                                >
                                                                    <button type="button" className="view_incentive_btn">VIEW INCENTIVE</button>
                                                                </td> */}
                                                            </tr>
                                                        </>
                                                    );
                                                })}
                                            </>
                                        ) : (
                                            <>
                                                <tr>
                                                    <td colSpan={8} className="text-center">

                                                        <h5 className="my-3">NO RECORD FOUND</h5>
                                                    </td>
                                                </tr>
                                            </>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* notifications and confirmations use react-toastify / window.confirm */}
        </>
    );
};

export default ViewExecutive;
